import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Component({
	selector: 'client-card',
	template: require('./client-card.html'),
	styles: [require('./client-card.scss')]
})
export class ClientCardComponent {
	@Input() client: any;
	@Input() type: string;
	@Input() gdprEnabled: boolean;
	@Output() onEdit: EventEmitter<any> = new EventEmitter();
	@Output() onSubscribe: EventEmitter<any> = new EventEmitter();
	@Output() onDelete: EventEmitter<any> = new EventEmitter();
	unsubscribe: Subject<void> = new Subject();

	constructor() {}

	editClient(): void {
		this.onEdit.emit();
	}

	deleteClient(): void {
		this.onDelete.emit();
	}

	subscribeClient(): void {
		this.onSubscribe.emit();
	}

	showSaveOptInModal(): void {
		$('#saveOptinConsentModal').modal('show');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/client/client-card/client-card.ts